<template>
  <div>
    <div
      class="EventList"
      v-for="{
        id,
        event,
        award,
        banner,
        end_date,
        city,
        start_date,
        meeting_planner_activation_date,
        meeting_planner_is_active,
        name,
        url,
        financial_entity,
        display_participants,
        participant_customers,
        slug,
        event_subtitle
      } in allEvents"
      :key="id"
    >
      <b-container class="bv-example-row">
        <router-link :to="getRoute(event, award, slug)">
          <div v-if="isMobileScreen" class="for-mobile-design">
            <div class="event-name">{{ name }}</div>
            <b-img :src="banner"></b-img>
            <div class="event-info">
              <div class="event-info-city-and-date">
                  <div class="event-city">{{ city }}</div>
                  <b>
                    {{ $formatDate.getUTCDate(start_date) }}
                    {{ $formatDate.getUTCMonth(start_date) }} -
                      {{ $formatDate.getUTCDate(end_date)}}
                    {{ $formatDate.getUTCMonth(end_date) }}
                    {{ $formatDate.getUTCYear(end_date) }}
                  </b>
              </div>
              <event-buttons
                v-if="!isBooked(url, participant_customers)"
                :slug="slug || null"
                :event-id="event || award"
                :eventUrl="url"
                :isAward="!!award"
                :mpActivation="meeting_planner_activation_date"
                :isActive="!!meeting_planner_is_active"
                :startDate="start_date"
                :hasBankAccount="checkBankAccount(financial_entity)"
                :isBooked="isBooked(url, participant_customers)"
                :displayParticipants="display_participants"
                :participants="participant_customers"
              />
            </div>
          </div>
          <b-row v-if="!isMobileScreen" class="single-event">
            <b-col sm="1" class="event-year">

             {{ $formatDate.getUTCYear(start_date) }}
            </b-col>
            <b-col sm="1" class="forEventDate">
              <p
                class="eventDate"
                :style="
                  isBooked(url, participant_customers) && 'color: #5cb85c'
                "
              >
                {{ $formatDate.getUTCDate(start_date) }}
                {{ $formatDate.getUTCMonth(start_date) }}
                <br />⌄<br />
                {{ $formatDate.getUTCDate(end_date)}}
                {{ $formatDate.getUTCMonth(end_date) }}

              </p>
            </b-col>

            <b-col sm="2" class="forEventImg">
              <b-img :src="banner"></b-img>
              <div
                v-if="isBooked(url, participant_customers)"
                class="booked-overlay"
              >
                <i class="fas fa-check" />
                <div>Booked</div>
              </div>
            </b-col>
            <b-col sm="4" class="forEventParaghraph">
              <div class="eventTxt">{{ name }}</div>
              <div class="eventSubtitleTxt">{{ event_subtitle }}</div>
              <p class="eventCity">{{ city }}</p>
            </b-col>
            <b-col sm="1" lg="2" class="float-right">
              <event-buttons
                :slug="slug || null"
                :event-id="event || award"
                :eventUrl="url"
                :isAward="!!award"
                :mpActivation="meeting_planner_activation_date"
                :isActive="!!meeting_planner_is_active"
                :startDate="start_date"
                :hasBankAccount="checkBankAccount(financial_entity)"
                :isBooked="isBooked(url, participant_customers)"
                :displayParticipants="display_participants"
                :participants="participant_customers"
              />
            </b-col>
          </b-row>
        </router-link>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import EventButtons from './EventButtons.vue';

export default {
  name: 'EventList',
  data() {
    return {
      allEntities: [],
      invoices: [],
    };
  },
  components: {
    EventButtons,
  },
  computed: {
    ...mapGetters({
      activeEvents: 'events/activeEvents',
      events: 'events/fetchEvents',
      userInfo: 'user/fetchUserInfo',
      isMobileScreen: 'isMobileScreen',
    }),
    allEvents(){
      return [...this.activeEvents, ...this.events]
    }
  },
  async mounted() {
    await this.fetchActiveEvents();
    await this.fetchEvents();
    await this.fetchPaymentEntities().then(
      ({ results }) => (this.allEntities = results),
    );
    await this.fetchUserInvoices(this.userInfo.id).then(
      ({ results }) => (this.invoices = results),
    );
  },

  methods: {
    ...mapActions({
      fetchEvents: 'events/fetchAllEvents',
      fetchActiveEvents: 'events/fetchActiveEvents',
      fetchPaymentEntities: 'companies/fetchPaymentEntities',
      fetchUserInvoices: 'user/fetchUserInvoices',
    }),
    moment(date) {
      return moment(new Date(date).toUTCString());
    },
    eventMonths(start, end) {
      return (
        this.moment(start).format('MMM') === this.moment(end).format('MMM')
      );
    },

    getRoute(event, award, slug) {
      return event
        ? { name: 'standardEvent', params: { slug: slug,  eventId: event }, }
        : { name: 'globalAwardsEvents', params: { awardId: award, slug } };
    },
    checkBankAccount(financial_entity) {
      let isBankAccountExists = false;
      this.allEntities.forEach((entity) => {
        if (entity.url === financial_entity && entity.bank_accounts.length) {
          isBankAccountExists = true;
        }
      });
      return isBankAccountExists;
    },
    isBooked(url, participants) {
      let index;
      if (participants) {
        index = participants.findIndex(
          participant => participant.customer_id === this.userInfo.id,
        );
        if (index !== -1) return true;
      }
      index = this.invoices.findIndex(
        invoice => invoice.event === url || invoice.award === url,
      );
      return index !== -1;
    },
  },
};
</script>

<style src="./css/event-list.css" scoped></style>
<style scoped>
  .float-right{
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .eventTxt{
    white-space: nowrap;
  }
</style>
